import { render, staticRenderFns } from "./OrganizationSignatoryRemoveDialog.vue?vue&type=template&id=b01da5dc&scoped=true"
import script from "./OrganizationSignatoryRemoveDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationSignatoryRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSignatoryRemoveDialog.vue?vue&type=style&index=0&id=b01da5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01da5dc",
  null
  
)

export default component.exports